<div class="container">
  <div class="not-found">
    <img src="assets/images/not-found.svg" />
    <h1>Página Não Encontrada</h1>
    <p>Verifique o link ou retorne à página anterior.</p>
    <app-botao text="Voltar" (click)="voltarHome()"></app-botao>
  </div>
</div>
